import * as React from 'react'
import { ParentSize } from '@vx/responsive'
import InfoCard from 'components/Cards/InfoCard'
import { GraphAustralia } from 'features/CallAnalytics/GraphAustralia'
import { GraphHorizontalBar } from 'features/CallAnalytics/GraphHorizontalBar'
import { flow, groupBy, mapValues, lowerCase, mapKeys, map, filter, orderBy } from 'lodash/fp'
import { ICall, INameVal } from 'features/CallAnalytics/types'

const mapWithKey = (map as any).convert({ cap: false })

const formatData = flow<ICall[], any, any, { [state: string]: number }>(
  groupBy('state'),
  mapValues(items => items.length),
  mapKeys(lowerCase) as any
)

const baseData = {
  nsw: 0,
  vic: 0,
  qld: 0,
  sa: 0,
  wa: 0,
  tas: 0,
  nt: 0,
  act: 0,
  ukn: 0,
}

const formatBarData = flow<{ [state: string]: number }, any, any, INameVal[]>(
  mapWithKey((item, state) => ({ name: state, value: item })),
  filter((item: INameVal) => item.value !== 0),
  orderBy(['value'], ['desc']) as any
)

export const CallsByState = ({ calls, loading }) => {
  const data = formatData(calls)
  const allData = {
    ...baseData,
    ...data,
  }
  return (
    <InfoCard style={{ height: '100%' }} title="Calls by state" loading={loading} allowOverflow>
      <div style={{ height: 'auto' }}>
        <ParentSize>
          {({ width }) => <GraphAustralia width={width} height={width * 0.7} data={allData} />}
        </ParentSize>
      </div>

      <ParentSize>
        {({ width }) => <GraphHorizontalBar width={width} data={formatBarData(allData)} />}
      </ParentSize>
    </InfoCard>
  )
}



// WEBPACK FOOTER //
// src/features/CallAnalytics/Cards/CallsByState/CallsByState.tsx